import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.css']
})
export class AuthLayoutComponent {

  mobileMenuActive: boolean;

  constructor(public renderer: Renderer2) { }

  isMobile() {
    return window.innerWidth <= 640;
  }

}
